import { Component, input } from '@angular/core';

@Component({
  selector: 'm-badge',
  templateUrl: './m-badge.component.html',
  styleUrls: ['./m-badge.component.scss']
})
export class MBadgeComponent {
  label = input<string>();
}
